import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-project-summary-box__sticky",
  "data-qa": "project-summary-box:Sticky"
}
const _hoisted_2 = {
  key: 1,
  class: "gfu-project-summary-box__header",
  "data-qa": "project-summary-box:Header"
}
const _hoisted_3 = {
  key: 2,
  class: "gfu-project-summary-box__actions",
  "data-qa": "project-summary-box:Actions"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-box gfu-box--flat gfu-project-summary-box', {
             'gfu-box--fill': $props.fill,
             'gfu-project-summary-box--borderless': $props.borderless
         }]),
    "data-qa": "project-summary-box:PledgeManager"
  }, [
    (_ctx.$slots.sticky)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "sticky")
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.$slots.header)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "header")
        ]))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "actions")
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}